import src from "IMAGE";
export default { src, width: 772, height: 122, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAYLCgwJEA8TBw8NFAUMChcFDgoaAwwIEwMOCBIBCAQLGOcBcFsl/uQAAAAASUVORK5CYII="};
